export default __webpack_public_path__ + "static/media/banner1.d75d77fc.png";